import React from 'react'
import { SortByType } from '../../constants'
import { useQuery } from '@apollo/client'
import {
  AppUsageAnalytics,
  AppUsageAnalyticsVariables,
  SortDirectionEnum,
  SurveyStatus,
} from '../../types'
import { APP_USAGE_ANALYTICS } from './operations'

interface Filters {
  answeredBetween?: Array<string | null>
  companyIds?: string[]
  groupIds?: string[]
  status?: SurveyStatus
}

export type Sorter = {
  sortBy?: string
  direction?: SortDirectionEnum
}

interface Props {
  filter?: Filters
  sorter?: Sorter
  page?: number
  pageLength?: number
  skip?: boolean
}

const PAGE_LENGTH = 10

export const useAppUsageAnalytics = ({
  filter,
  page = 1,
  pageLength = PAGE_LENGTH,
  skip = false,
  sorter,
}: Props = {}) => {
  const { answeredBetween, companyIds, status, groupIds } = filter || {}
  const queryVariables = React.useMemo<AppUsageAnalyticsVariables>(
    () => ({
      filterData: {
        answeredBetween,
        companyIds,
        groupIds,
        status,
      },
      pagination: {
        from: pageLength * (page - 1),
        length: pageLength,
        sortBy: sorter?.sortBy || SortByType.ID,
        direction: sorter?.direction || SortDirectionEnum.ASC,
      },
    }),
    [answeredBetween]
  )
  const testAnalyticsQuery = useQuery<AppUsageAnalytics, AppUsageAnalyticsVariables>(
    APP_USAGE_ANALYTICS,
    {
      variables: queryVariables,
      skip,
    }
  )

  return testAnalyticsQuery
}
